module.exports = __webpack_public_path__ + "img/mpxgt.6407d00c.png";